import type { ApolloError } from "@kv/apollo-client";
import type { FC } from "react";

import ApolloErrors from "~/components/ApolloErrors";
import LoadingIndicator from "~/components/LoadingIndicator";



export interface AsyncContentProps {
  loading?: boolean;
  error?: ApolloError;
}

const AsyncContent: FC<AsyncContentProps> = ({ children, loading, error }) => {
  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ApolloErrors error={error} />;
  }

  return <>{children}</>;
};

export default AsyncContent;
